export default __webpack_public_path__ + "static/benifitImage2-195401c1756d32603d53c5e8bc10200f.png";